import { render, staticRenderFns } from "./ResendConfirmationOptions.vue?vue&type=template&id=26d6598e&scoped=true"
import script from "./ResendConfirmationOptions.vue?vue&type=script&lang=js"
export * from "./ResendConfirmationOptions.vue?vue&type=script&lang=js"
import style0 from "./ResendConfirmationOptions.vue?vue&type=style&index=0&id=26d6598e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d6598e",
  null
  
)

export default component.exports